import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Logo from '../Admin/assets/images/logo1.png';
import './index.less';

interface IProps extends RouteComponentProps {};
interface IState {
  fileUrl: string
}

export class SeeFile extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      fileUrl: ''
    };
  }
  componentDidMount() {
    const { pathname, search } = this.props.location;
    let url = pathname.substring(9);
    this.setState({
      fileUrl: url + search
    })
  }
  render() {
    const { fileUrl } = this.state;
    return (
      <div className="seefile">
        <div className="top">
          <div className="img">
            <img src={Logo} alt=""/>
          </div>
          <h3>浏览文件</h3>
        </div>
        {/* <iframe width="100%" height="100%" src={'http://view.xdocin.com/xdoc?_xdoc=' + encodeURIComponent(fileUrl)}></iframe> */}
        <iframe width="100%" height="100%" title="navigation" src={fileUrl}></iframe>
      </div>
    )
  }
}

export default SeeFile;
